var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLargeColored(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2631",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconLargeColored_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2443",
    fill: "none",
    d: "M0 0h80v80H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2630",
    clipPath: "url(#iconLargeColored_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20534",
    d: "M40 0A40 40 0 110 40 40 40 0 0140 0",
    fill: "#e0fff6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20535",
    d: "M47.209 44.162L40 48.323l-7.209-4.161v-8.324L40 31.676l7.209 4.162zm2.506.723v-9.771a1.253 1.253 0 00-.626-1.085l-8.462-4.886a1.252 1.252 0 00-1.253 0l-8.459 4.887a1.252 1.252 0 00-.626 1.085v9.771a1.252 1.252 0 00.626 1.084l8.462 4.885a1.252 1.252 0 001.253 0l8.462-4.885a1.252 1.252 0 00.627-1.085",
    fill: "#038258"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20536",
    d: "M43.906 57.96v-3.825l6.382-3.685 3.312 1.913zm12.827-6.682l-5.818-3.359a1.252 1.252 0 00-1.253 0l-7.635 4.408a1.254 1.254 0 00-.626 1.085v6.718a1.253 1.253 0 001.879 1.085l13.453-7.767a1.253 1.253 0 000-2.17",
    fill: "#038258"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20537",
    d: "M36.093 57.96l-9.695-5.6 3.312-1.913 6.382 3.685zm1.879-5.633l-7.635-4.409a1.254 1.254 0 00-1.253 0l-5.818 3.36a1.253 1.253 0 000 2.17l13.453 7.767a1.253 1.253 0 001.88-1.085v-6.718a1.253 1.253 0 00-.626-1.085",
    fill: "#038258"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20538",
    d: "M25.805 43.683l-3.312 1.913V34.401l3.312 1.913zm2.506.723V35.59a1.253 1.253 0 00-.626-1.085l-5.818-3.359a1.253 1.253 0 00-1.88 1.085v15.534a1.253 1.253 0 001.88 1.085l5.818-3.36a1.252 1.252 0 00.626-1.085",
    fill: "#038258"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20539",
    d: "M57.507 45.596l-3.312-1.912v-7.37l3.312-1.912zm1.876-14.45a1.254 1.254 0 00-1.253 0l-5.818 3.359a1.253 1.253 0 00-.627 1.085v8.816a1.254 1.254 0 00.626 1.085l5.818 3.36a1.253 1.253 0 001.879-1.085V32.231a1.253 1.253 0 00-.626-1.085",
    fill: "#038258"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20540",
    d: "M36.093 22.04v3.825l-6.382 3.684-3.312-1.912zm-12.827 6.682l5.818 3.359a1.254 1.254 0 001.253 0l7.635-4.408a1.254 1.254 0 00.626-1.085v-6.719a1.253 1.253 0 00-1.879-1.085l-13.453 7.768a1.253 1.253 0 000 2.17",
    fill: "#038258"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20541",
    d: "M43.906 22.04l9.695 5.6-3.312 1.912-6.382-3.684zm-1.879 5.633l7.635 4.408a1.254 1.254 0 001.253 0l5.818-3.359a1.253 1.253 0 000-2.17l-13.457-7.767a1.253 1.253 0 00-1.879 1.085v6.718a1.254 1.254 0 00.626 1.085",
    fill: "#038258"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLargeColored);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconLargeColored.d1825c32.svg";
export { MemoForwardRef as ReactComponent };